import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

import GramRosa from "./InfluencerTheGramAssets/TheGram_Profile_Rosa.jpg";
import GramEthan from "./InfluencerTheGramAssets/TheGram_Profile_Ethan.png";
import GramJackson from "./InfluencerTheGramAssets/TheGram_Profile_Jackson.png";
import GramTK from "./InfluencerTheGramAssets/TheGram_Profile_TK.png";
import GramNoah from "./InfluencerTheGramAssets/TheGram_Profile_Noah.png";
import GramTiffany from "./InfluencerTheGramAssets/TheGram_Profile_Tiffany.png";
import { TK_Text_photo } from "./InfluencerPhotoContent";

export const GramChatsConst: Chat_content[] = [
  {
    icon: GramNoah,
    type: "individual",
    name: "Noah Williams",
    messages: [
      {
        content: {
          type: "text",
          content: "Where r u?",
        },
        timestamp: "2024-05-27T01:13:00Z",
        from: "Noah",
        status: "Unread",
      },
    ],
    read: false,
  },
  {
    icon: GramJackson,
    type: "individual",
    name: "Jackson Davis",
    messages: [
      {
        content: {
          type: "text",
          content: "Where r u bro?",
        },
        timestamp: "2024-05-26T23:53:00Z",
        from: "",
        status: "Unread",
      },
    ],
    read: false,
  },
  {
    icon: GramEthan,
    type: "individual",
    name: "Ethan White",
    messages: [
      {
        content: {
          type: "text",
          content: "Ethan sent an attachment",
        },
        timestamp: "2024-05-26T23:48:00Z",
        from: "",
        status: "Read",
      },
    ],
    read: false,
  },
  {
    icon: GramRosa,
    type: "individual",
    name: "Rosa Gutierrez",
    messages: [
      {
        content: {
          type: "text",
          content: "Am back in our room",
        },
        timestamp: "2024-05-26T23:33:00Z",
        from: "",
        status: "Unread",
      },
    ],
    read: false,
  },
  {
    icon: GramTK,
    type: "individual",
    name: "TK",
    messages: [
      {
        content: {
          type: "text",
          content: "I’m outside now",
        },
        timestamp: "2024-05-26T22:01:00Z",
        from: "TK",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "walking to hotel now ",
        },
        timestamp: "2024-05-26T22:01:00Z",
        from: "TK",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Cmon man u said u’d come out when we spoke inside earlier?",
        },
        timestamp: "2024-05-26T22:05:00Z",
        from: "TK",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Am at the hotel come we need to talk in private, meet here ",
        },
        timestamp: "2024-05-26T22:28:00Z",
        from: "TK",
        status: "Read",
      },
      {
        content: {
          type: "photo",
          content: TK_Text_photo,
        },
        timestamp: "2024-05-26T22:28:00Z",
        from: "TK",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Ffs josh why u so scared of me? U said u would come",
        },
        timestamp: "2024-05-26T22:28:00Z",
        from: "TK",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "this is useless i’m comin back to party now",
        },
        timestamp: "2024-05-26T22:41:00Z",
        from: "TK",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "coward",
        },
        timestamp: "2024-05-26T22:41:00Z",
        from: "TK",
        status: "Read",
      },
    ],
    read: false,
  },
  {
    icon: GramTiffany,
    type: "individual",
    name: "Tiffany Johnson",
    messages: [
      {
        content: {
          type: "text",
          content:
            "U know what its fine, don’t even answer. See u in Bali, I heard ur coming.",
        },
        timestamp: "2024-05-24T16:32:00Z",
        from: "",
        status: "Read",
      },
    ],
    read: true,
  },
];
